import React, { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getexploreListing, } from "store/actions";
import CategoryCard2 from "Pages/category/CategoryCard2";
import { Oval } from "react-loader-spinner";
export default memo(function DigitalArtcollection(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { exploreListing } = useSelector((state) => state?.SellItems);
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => { setLoading(false) }, 3000)
  }, [])
  useEffect(() => {
    dispatch(getexploreListing({}))
  }, [])
  const desiredIndexes = [1, 2, 5, 7];


  return (
    <section className="DigitalArtcollection-main position-relative">
      {(loading) && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <Container>
        <Row>

          <Col lg={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <div className="DigitalArtcollection-head">
                <h2 className="mb-3">Physical Art </h2>
                <p>A brief sample of available Physical Artworks</p>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <Row>
              <div className="col-xl-3">
                <div className="artItemBoxNew" >
                  <div className="imgBox" style={{ cursor: 'pointer' }} onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/abstract-design.jpg', artname: 'Art Demo', price: '$ 100.00000', view: 10, likes: 4,
                      description: 'This captivating mural features a large, hyper-realistic eye seamlessly blended into a vibrant explosion of colorful leaves and abstract shapes. Painted across a building wall and door, the artwork symbolizes a fusion of nature and human perception, with rich tones of orange, blue, red, and green creating a powerful visual impact.',
                      Aboutseller: 'I am a passionate street artist who blends realism with vibrant nature-inspired designs. My murals, like the one shown, aim to transform spaces and evoke emotion through bold color and detail. Let’s create art that tells a story.',
                      EditionType:'Open', ImageSize:'24"H x 19"W', EditionSize:'Open', NumberAvailable:'Open', PrintMaterial:'Paper'  
                    }
                  }



                )}>
                    <div className="artistNameBox">
                      <div className="d-flex align-items-center gap-2">
                        <img src="../../images/jpg/person-painting.jpg" alt="" />
                        <h5>Test Demo</h5>
                      </div>
                    </div>
                    <div className="imginn">
                      <img src="../../images/jpg/abstract-design.jpg" alt="Placeholder Image" />
                    </div>
                  </div>
                  <div className="contBox" >
                    <div className="arthead">
                      <h2 className="productName" title="Art Demo">Art Demo </h2>
                    </div>
                    <div className="artPriceBox align-items-start mt-2">
                      <div>
                        <div className="artRate d-block text-start">
                          <h4>$ 100.00000 </h4>
                          <div className="dropdown">
                            <button type="button" id="dropdown-basic" aria-expanded="false" className="dropdown-toggle btn btn-secondary">
                              <strong className="d-flex align-items-center gap-2">Select Currency <i className="fa-solid fa-angle-down"></i></strong>
                            </button>
                          </div>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <img src="/images/svg/eyeNew.svg" width="25" height="25" alt="" />
                          <h5>10</h5>
                        </li>
                        <li>
                          <img src="/images/svg/likeNew.svg" width="25" height="25" alt="" />
                          <h5>4</h5>
                        </li>
                      </ul>
                    </div>
                    <button className="exploreBtn" onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/abstract-design.jpg', artname: 'Art Demo', price: '$ 100.00000', view: 10, likes: 4,
                      description: 'This captivating mural features a large, hyper-realistic eye seamlessly blended into a vibrant explosion of colorful leaves and abstract shapes. Painted across a building wall and door, the artwork symbolizes a fusion of nature and human perception, with rich tones of orange, blue, red, and green creating a powerful visual impact.',
                      Aboutseller: 'I am a passionate street artist who blends realism with vibrant nature-inspired designs. My murals, like the one shown, aim to transform spaces and evoke emotion through bold color and detail. Let’s create art that tells a story.',
                    EditionType:'Open', ImageSize:'24"H x 19"W', EditionSize:'Open', NumberAvailable:'Open', PrintMaterial:'Paper'
                    }
                  }



                )}

                    >Explore Now</button>
                  </div>
                </div>
              </div>

              <div className="col-xl-3">
                <div className="artItemBoxNew" >
                  <div className="imgBox" style={{ cursor: 'pointer' }} onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/art-with-woman-portrait.jpg', artname: 'Art Demo', price: '$ 100.00', view: 10, likes: 4,
                      description: 'A mesmerizing portrait of a woman created with splashes of vibrant orange, green, and yellow hues, blending realism with expressive watercolor textures. The floral elements surrounding her evoke a sense of beauty and nature harmony.',
                      Aboutseller: 'I specialize in expressive portrait art that merges emotion with vibrant nature-inspired elements. My work captures the strength and beauty of women through bold strokes, watercolor blends, and symbolic florals. I aim to celebrate identity, energy, and imagination in every piece.',
                    EditionType:'Open', ImageSize:'24"H x 19"W', EditionSize:'Open', NumberAvailable:'Open', PrintMaterial:'Paper'
                    }
                  }
                )}>
                    <div className="artistNameBox">
                      <div className="d-flex align-items-center gap-2">
                        <img src="../../images/jpg/person-painting.jpg" alt="" />
                        <h5>Test Demo</h5>
                      </div>
                    </div>
                    <div className="imginn">
                      <img src="../../images/jpg/art-with-woman-portrait.jpg" alt="Placeholder Image" />
                    </div>
                  </div>
                  <div className="contBox">
                    <div className="arthead">
                      <h2 className="productName" title="Art Demo">Art Demo </h2>
                    </div>
                    <div className="artPriceBox align-items-start mt-2">
                      <div>
                        <div className="artRate d-block text-start">
                          <h4>$ 100.00 </h4>
                          <div className="dropdown">
                            <button type="button" id="dropdown-basic" aria-expanded="false" className="dropdown-toggle btn btn-secondary">
                              <strong className="d-flex align-items-center gap-2">Select Currency <i className="fa-solid fa-angle-down"></i></strong>
                            </button>
                          </div>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <img src="/images/svg/eyeNew.svg" width="25" height="25" alt="" />
                          <h5>10</h5>
                        </li>
                        <li>
                          <img src="/images/svg/likeNew.svg" width="25" height="25" alt="" />
                          <h5>4</h5>
                        </li>
                      </ul>
                    </div>
                    <button className="exploreBtn"
                    onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/art-with-woman-portrait.jpg', artname: 'Art Demo', price: '$ 100.00', view: 10, likes: 4,
                      description: 'A mesmerizing portrait of a woman created with splashes of vibrant orange, green, and yellow hues, blending realism with expressive watercolor textures. The floral elements surrounding her evoke a sense of beauty and nature harmony.',
                      Aboutseller: 'I specialize in expressive portrait art that merges emotion with vibrant nature-inspired elements. My work captures the strength and beauty of women through bold strokes, watercolor blends, and symbolic florals. I aim to celebrate identity, energy, and imagination in every piece.',
                    EditionType:'Open', ImageSize:'24"H x 19"W', EditionSize:'Open', NumberAvailable:'Open', PrintMaterial:'Paper'
                    }
                  }
                )}
                    >Explore Now</button>
                  </div>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="artItemBoxNew" >
                  <div className="imgBox" style={{ cursor: 'pointer' }} onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/painting-representing-krishna.jpg', artname: 'Art Demo', price: '$ 150.00', view: 10, likes: 4,
                      description: 'A divine and soulful depiction of a blue-skinned goddess, adorned with traditional jewelry and surrounded by abstract florals. The colors are rich and earthy, creating a serene spiritual essence.',
                      Aboutseller: 'As a spiritual and cultural artist, I focus on divine expressions and Indian mythological themes. My art blends tradition with modern color palettes to honor sacred femininity and inner grace. Every piece is a tribute to timeless beauty and spiritual depth.',
                    EditionType:'Limited Edition', ImageSize:'24"H x 19"W', EditionSize:'20', NumberAvailable:'8', PrintMaterial:'Canvas'
                    }
                  }
                )}>
                    <div className="artistNameBox">
                      <div className="d-flex align-items-center gap-2">
                        <img src="../../images/jpg/person-painting.jpg" alt="" />
                        <h5>Test Demo</h5>
                      </div>
                    </div>
                    <div className="imginn">
                      <img src="../../images/jpg/painting-representing-krishna.jpg" alt="Placeholder Image" />
                    </div>
                  </div>
                  <div className="contBox">
                    <div className="arthead">
                      <h2 className="productName" title="Art Demo">Art Demo </h2>
                    </div>
                    <div className="artPriceBox align-items-start mt-2">
                      <div>
                        <div className="artRate d-block text-start">
                          <h4>$ 150.00  </h4>
                          <div className="dropdown">
                            <button type="button" id="dropdown-basic" aria-expanded="false" className="dropdown-toggle btn btn-secondary">
                              <strong className="d-flex align-items-center gap-2">Select Currency <i className="fa-solid fa-angle-down"></i></strong>
                            </button>
                          </div>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <img src="/images/svg/eyeNew.svg" width="25" height="25" alt="" />
                          <h5>10</h5>
                        </li>
                        <li>
                          <img src="/images/svg/likeNew.svg" width="25" height="25" alt="" />
                          <h5>4</h5>
                        </li>
                      </ul>
                    </div>
                    <button className="exploreBtn"
                    onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/painting-representing-krishna.jpg', artname: 'Art Demo', price: '$ 150.00', view: 10, likes: 4,
                      description: 'A divine and soulful depiction of a blue-skinned goddess, adorned with traditional jewelry and surrounded by abstract florals. The colors are rich and earthy, creating a serene spiritual essence.',
                      Aboutseller: 'As a spiritual and cultural artist, I focus on divine expressions and Indian mythological themes. My art blends tradition with modern color palettes to honor sacred femininity and inner grace. Every piece is a tribute to timeless beauty and spiritual depth.',
                   EditionType:'Limited Edition', ImageSize:'24"H x 19"W', EditionSize:'20', NumberAvailable:'8', PrintMaterial:'Canvas'
                    }
                  }
                )}
                    >Explore Now</button>
                  </div>
                </div>
              </div>
              <div className="col-xl-3">
                <div className="artItemBoxNew" >
                  <div className="imgBox" style={{ cursor: 'pointer' }} onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/colorful-humidity-glass.jpg', artname: 'Art Demo', price: '$ 200.00', view: 10, likes: 4,
                      description: 'A poetic, moody capture of flowers seen through a misted, rain-covered glass. The soft focus and blurred textures highlight the gentle beauty of red and pink blossoms in a tranquil, dreamlike scene.',
                      Aboutseller: 'Nature is my canvas. I capture fleeting, delicate moments—like flowers behind a misted window—to evoke a sense of calm and nostalgia.',
                      EditionType:'Limited Edition', ImageSize:'24"H x 19"W', EditionSize:'20', NumberAvailable:'8', PrintMaterial:'Canvas'}
                  }
                )}>
                    <div className="artistNameBox">
                      <div className="d-flex align-items-center gap-2">
                        <img src="../../images/jpg/person-painting.jpg" alt="" />
                        <h5>Test Demo</h5>
                      </div>
                    </div>
                    <div className="imginn">
                      <img src="../../images/jpg/colorful-humidity-glass.jpg" alt="Placeholder Image" />
                    </div>
                  </div>
                  <div className="contBox">
                    <div className="arthead">
                      <h2 className="productName" title="Art Demo">Art Demo </h2>
                    </div>
                    <div className="artPriceBox align-items-start mt-2">
                      <div>
                        <div className="artRate d-block text-start">
                          <h4>$ 200.00 </h4>
                          <div className="dropdown">
                            <button type="button" id="dropdown-basic" aria-expanded="false" className="dropdown-toggle btn btn-secondary">
                              <strong className="d-flex align-items-center gap-2">Select Currency <i className="fa-solid fa-angle-down"></i></strong>
                            </button>
                          </div>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <img src="/images/svg/eyeNew.svg" width="25" height="25" alt="" />
                          <h5>10</h5>
                        </li>
                        <li>
                          <img src="/images/svg/likeNew.svg" width="25" height="25" alt="" />
                          <h5>4</h5>
                        </li>
                      </ul>
                    </div>
                    <button className="exploreBtn" onClick={() => navigate(

                  `/Physical_Artwork`,
                  {
                    state: {
                      artist: 'Test Demo', image: '../../images/jpg/colorful-humidity-glass.jpg', artname: 'Art Demo', price: '$ 200.00', view: 10, likes: 4,
                      description: 'A poetic, moody capture of flowers seen through a misted, rain-covered glass. The soft focus and blurred textures highlight the gentle beauty of red and pink blossoms in a tranquil, dreamlike scene.',
                      Aboutseller: 'Nature is my canvas. I capture fleeting, delicate moments—like flowers behind a misted window—to evoke a sense of calm and nostalgia.',
                    EditionType:'Limited Edition', ImageSize:'24"H x 19"W', EditionSize:'20', NumberAvailable:'8', PrintMaterial:'Canvas'
                    }
                  }
                )}>
                      Explore Now</button>
                  </div>
                </div>
              </div>

            </Row>
          </Col>

          <Col className="mt-5" lg={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <div className="DigitalArtcollection-head">
                <h2 className="mb-3">Explore </h2>
                <p>A brief sample of available Digital Artworks</p>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <Row>
              {(exploreListing?.length > 0) ? (
                <>
                  {exploreListing?.map((nftData, idx) => {
                    return (

                      <Col className="mb-4" lg={3} key={idx}>
                        <CategoryCard2 data={nftData} />
                      </Col>
                    )
                  })}
                </>
              ) : (<>
                <div className="text-center d-grid justify-content-center dataNotFound py-5">
                  <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                  <h3>No Digital Artworks Available</h3>
                </div>
              </>)}

            </Row>
          </Col>
          <div className="text-center show-wrap">
            <Link className="link-text" to="/art-genres">
              <button className="LearnMoreBtn"> Explore All Artworks <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3312 7.08301L18.3228 7.08301L18.3144 7.08357L18.1788 7.09271L18.1704 7.09327L18.162 7.09441C17.5516 7.17721 17.0812 7.69994 17.0812 8.33301V8.34147L17.0818 8.34992L17.091 8.48561L17.0916 8.49397L17.0927 8.50227C17.1754 9.11269 17.6982 9.58301 18.3312 9.58301H25.3132L16.3337 18.5638L12.5499 14.7801L12.5434 14.7736L12.5365 14.7676L12.4243 14.6708L12.4173 14.6648L12.4099 14.6593C11.9204 14.2962 11.2261 14.3363 10.7822 14.7801L10.7821 14.7801L2.78213 22.7801L2.77561 22.7866L2.76959 22.7936L2.67277 22.9059L2.66678 22.9128L2.66131 22.9202C2.29809 23.4097 2.3382 24.1039 2.78212 24.5479L2.78213 24.5479C3.27028 25.0361 4.06175 25.0361 4.5499 24.5479L11.666 17.4318L15.4499 21.2155L15.4564 21.222L15.4633 21.228L15.5754 21.3248L15.5824 21.3308L15.5898 21.3363C16.0794 21.6996 16.7738 21.6593 17.2177 21.2156L17.2177 21.2155L27.0827 11.3486L27.0832 18.3382V18.3467L27.0838 18.3551L27.093 18.4908L27.0936 18.4992L27.0947 18.5076C27.1775 19.1178 27.7003 19.5882 28.3332 19.5882C29.0237 19.5882 29.5832 19.0285 29.5832 18.3382L29.5827 8.29499V8.28256L29.5814 8.27019L29.5689 8.14459L29.5675 8.1309L29.5647 8.11744L29.5466 8.0321L29.5445 8.02228L29.5416 8.01266L29.5161 7.92722L29.512 7.91342L29.5063 7.90018L29.4547 7.77975L29.448 7.76402L29.4392 7.74936L29.3669 7.6292L29.3595 7.61679L29.3506 7.60533L29.2926 7.53016L29.2858 7.52136L29.2783 7.5132L29.224 7.45448L29.2242 7.45434L29.2171 7.44726C29.1088 7.33913 28.9843 7.25364 28.8495 7.19432L28.8495 7.1943L28.8463 7.19295L28.766 7.15889L28.7512 7.15262L28.7357 7.1483L28.604 7.11149L28.5877 7.10695L28.571 7.10463L28.4373 7.08607L28.4202 7.0837L28.403 7.0837L18.3312 7.08301Z" fill="white" stroke="white" stroke-width="0.5" />
              </svg>
              </button>
            </Link>
          </div>
        </Row>
        {/* <Row>
          <Col lg={12} >
            <div className="d-flex align-items-baseline justify-content-between mb-2">
              <div className="DigitalArtcollection-head">
                <h2 className="mb-4 mt-3">Printable NFT’s </h2>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <Row>
              {(exploreListing?.length > 0) ? (
                <>
                  {exploreListing?.map((nftData, idx) => {
                    return (

                      <Col className="mb-4" lg={3} key={idx}>
                        <CategoryCard2 data={nftData} />
                      </Col>
                    )
                  })}
                </>
              ) : (<>
                <div className="text-center d-grid justify-content-center dataNotFound py-5">
                  <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                  <h3>No NFTs Available</h3>
                </div>
              </>)}

            </Row>
          </Col>
         
        </Row> */}
      </Container>
    </section>
  );
})
